export default "__VITE_ASSET__2a4bad1b__"